import { BrowserRouter } from 'react-router-dom'
import { AppRoutes } from './router'

const LINE_URL = 'https://line.me/R/ti/p/@398bfznn'

function LineFloatingCTA() {
  return (
    <a
      href={LINE_URL}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="LINEで簡単1分査定。写真を送るだけ"
      className="fixed z-[100] right-2.5 bottom-2.5 sm:right-5 sm:bottom-5 group"
      style={{ marginBottom: 'env(safe-area-inset-bottom)' }}
    >
      <div className="w-[88px] sm:w-[108px] rounded-2xl bg-white px-2 pt-2 pb-1.5 sm:px-2.5 sm:pt-2.5 sm:pb-2 shadow-[0_8px_28px_rgba(0,0,0,0.24)] ring-1 ring-black/5 transition-transform duration-200 group-hover:-translate-y-1 group-active:scale-95">
        <div className="mx-auto flex h-[54px] w-[54px] sm:h-[68px] sm:w-[68px] items-center justify-center rounded-[17px] sm:rounded-[20px] bg-[#06C755]">
          <div className="relative flex h-[37px] w-[41px] sm:h-[42px] sm:w-[47px] items-center justify-center rounded-[50%] bg-white">
            <span className="text-[12px] sm:text-[14px] font-black tracking-[-0.04em] text-[#06C755]">LINE</span>
            <span
              aria-hidden="true"
              className="absolute -bottom-[5px] left-[9px] h-0 w-0 border-l-[7px] border-l-transparent border-t-[10px] border-t-white border-r-[2px] border-r-transparent rotate-[18deg]"
            />
          </div>
        </div>
        <div className="mt-1.5 sm:mt-2 text-center text-black leading-[1.25]">
          <div className="text-[11px] sm:text-[12px] font-extrabold">簡単1分査定</div>
          <div className="mt-0.5 text-[9px] sm:text-[10px] font-bold">写真を送るだけ！</div>
        </div>
      </div>
    </a>
  )
}

function App() {
  return (
    <BrowserRouter>
      <AppRoutes />
      <LineFloatingCTA />
    </BrowserRouter>
  )
}

export default App
